import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Download, ExternalLink, Loader2, Megaphone } from "lucide-react";
import { API } from "../lib/api";
import { Shell } from "./PaymentSuccess";
import { DiamondMark } from "../components/Brand";

export default function AccessPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/access/${token}`)
      .then((res) => { if (alive) { setData(res.data ?? null); setState("ok"); } })
      .catch(() => { if (alive) setState("error"); });
    return () => { alive = false; };
  }, [token]);

  if (state === "loading") return <Shell><Loader2 className="w-8 h-8 text-gold animate-spin mx-auto" /></Shell>;
  if (state === "error") return (
    <Shell>
      <h1 className="font-display font-black uppercase text-2xl" data-testid="access-error">Access page not found</h1>
      <p className="mt-3 text-sm text-violet-200/80">Check the link in your delivery email, or DM us on Instagram @seedosellz.</p>
    </Shell>
  );
  return (
    <Shell>
      <p className="text-[11px] tracking-[0.4em] uppercase text-gold flex items-center justify-center gap-2"><DiamondMark className="w-3 h-3" /> Private access</p>
      <h1 className="mt-4 font-display font-black uppercase text-3xl leading-tight" data-testid="access-product-name">{data?.product_name ?? "Your purchase"}</h1>
      <div className="mt-6 border-l-2 border-violet-500 bg-violet-950/50 px-4 py-3 text-left flex gap-3" data-testid="access-referral-message">
        <Megaphone className="w-4 h-4 text-gold shrink-0 mt-0.5" />
        <p className="text-sm text-amber-100"><strong>Important:</strong> {data?.message}</p>
      </div>
      <a href={`${process.env.REACT_APP_BACKEND_URL}${data?.view_path ?? ""}`} target="_blank" rel="noreferrer" className="btn-gold mt-6 w-full py-4 text-xs" data-testid="access-view-pdf-btn">
        <ExternalLink className="w-4 h-4 mr-2" /> View my PDF
      </a>
      <a href={`${process.env.REACT_APP_BACKEND_URL}${data?.download_path ?? ""}`}
        className="mt-3 w-full inline-flex items-center justify-center py-3.5 text-[11px] font-bold tracking-[0.22em] uppercase border border-gold/50 text-gold hover:bg-white/5 transition-colors" data-testid="access-download-btn">
        <Download className="w-4 h-4 mr-2" /> Download PDF
      </a>
      <p className="mt-5 text-xs text-violet-300">This page is private to you. Don't share the link.</p>
    </Shell>
  );
}
